import script from "./SessionDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionDescription.vue?vue&type=script&setup=true&lang=js"

import "./SessionDescription.vue?vue&type=style&index=0&id=04062580&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04062580"]])

export default __exports__